import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { IConversationLink } from './types';
import { ExternalLink as LeadIcon } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { WHATSAPP_COLOR } from 'src/constants/variants/variants';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(() => ({
    root: {},
    button: {
        marginTop: '0.5em',
        color: WHATSAPP_COLOR,
    },
    icon: {
        fontSize: 16,
        color: WHATSAPP_COLOR,
        marginLeft: 4,
    },
}));

export const ConversationLink = ({
    conversation,
    area,
    api,
    ...props
}: IConversationLink) => {
    const classes = useStyles();

    const { t } = useTranslation();
    const history = useHistory();

    const hanldeRedirect = () =>
        history.push(`/conversations?id=${conversation}&area=${area}`);

    return (
        <Button
            onClick={hanldeRedirect}
            className={classes.button}
            fullWidth
            startIcon={<LeadIcon className={classes.icon} />}
            {...props}
        >
            {t('Leads.GoConversation')}
        </Button>
    );
};
